import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AppModalService } from './modal.service';
import { AppModalComponent } from './modal.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [AppModalComponent],
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  providers: [AppModalService],
})
export class AppModalModule {}
